<div class="tasks-card">
  <div class="tasks-card__header" ubi-curve-header xlarge>
    <div class="tasks-card__header-text">
      {{ 'dashboard.task_list.header' | translate }}
    </div>
  </div>
  <artemis-popover>
    <ng-container *ngFor="let content of ('dashboard.task_list.info.content' | translate)">
      <p>{{content.dashboard_contains}}</p>
      <p>{{content.header}}</p>
      <ol>
        <li>
          {{ content.perform }} <em>{{content.periodic_review}}</em>
        </li>
        <li>
          {{ content.clear }}
          <em>{{content.expiring_documents}}</em>
          {{ content.that_are_expiring }}
        </li>
        <li>
          {{ content.review }}
          <em>{{content.pending_cases}}</em>
        </li>
        <li>
          {{ content.review }}
          <em>{{content.overdue_cases}}</em>
          {{ content.that_are_pending_cases }}
          {{(overdueTaskPeriod$ | async)?.value}}
          days
        </li>
      </ol>
    </ng-container>
  </artemis-popover>
  <div class="tasks-card__content">
    <artemis-loading-spinner *ngIf="!donutData || donutData.length <= 0"></artemis-loading-spinner>
    <div class="tasks-card__infographics" *ngIf="donutData && donutData.length > 0">
      <ubi-donut-chart chartClass="donut-chart__donut" legendClass="donut-chart__legend"
                       [chartData]="donutData" [chartTitle]="tasksChartTitle" [options]="donutChartColorPalette[currentTheme]"
                        (onSelect)="onSelectHandler($event)">
      </ubi-donut-chart>
    </div>
    <ng-container [ngSwitch]="currentTable">
      <artemis-task-table *ngSwitchCase="'Pending Task Table'" [taskType]="'pending'"></artemis-task-table>
      <artemis-task-table *ngSwitchCase="'Overdue Task Table'" [taskType]="'overdue'"></artemis-task-table>
      <artemis-expiring-document-table *ngSwitchCase="'Expiring Document Table'"></artemis-expiring-document-table>
      <artemis-periodic-review-table *ngSwitchCase="'Periodic Review Table'"></artemis-periodic-review-table>
    </ng-container>
  </div>
</div>
